import { customAuthenticationService } from '@/services/custom-authentication';
import { useMutation } from '@tanstack/react-query';

interface ForgotPasswordResult {
  success: boolean;
  message?: string;
  error?: string;
}

export const useCustomAuthenticationConfirmPassword = () => {
  return useMutation<
    ForgotPasswordResult,
    Error,
    { email: string; verificationCode: string; newPassword: string }
  >({
    mutationFn: async ({ email, verificationCode, newPassword }) => {
      const result = await customAuthenticationService.confirmForgotPassword(
        email,
        verificationCode,
        newPassword
      );

      if (!result.success) {
        throw new Error(
          result.error || 'Erro ao confirmar recuperação de senha'
        );
      }

      return result;
    },
    // Erros 4xx (token inválido, expirado) não devem repetir a requisição
    retry: false,
  });
};
